import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mainMenu: localStorage.getItem('mainMenu') ? localStorage.getItem('mainMenu') : '/home',
    subMenu:localStorage.getItem('subMenu') ? localStorage.getItem('subMenu') : ''
  },
  mutations: {
    // 修改数据仓库的事件
    changeMainMenu(state,value){
      state.mainMenu = value
      localStorage.setItem('mainMenu',value)
    },
    changeSubMenu(state,value){
      state.subMenu = value
      localStorage.setItem('subMenu',value)
    }
  },
  actions: {
    setMainMenu(context,value){  
      context.commit('changeMainMenu',value)
    },
    setSubMenu(context,value){  
      context.commit('changeSubMenu',value)
    }
  },
  modules: {
  }
})
